import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=ed31effa"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports